<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Nombre de Plantilla -->
      <v-col cols="12" sm="5" md="5">
        <v-text-field
          v-model="editedItem.DescPlantilla_ID"
          label="Nombre de Plantilla:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo de plantilla -->
      <v-col cols="12" sm="5" md="5">
        <v-autocomplete
          v-model="editedItem.Tipo"
          :items="ArrayTipoPlantilla"
          :item-title="
            (ArrayTipoPlantilla) =>
              ArrayTipoPlantilla.Valor + '-' + ArrayTipoPlantilla.Descripcion
          "
          item-value="Valor"
          label="Tipo de plantilla:"
          dense
          :rules="[rules.required]"
          @update:modelValue="ChangeTipoPlantilla()"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Estado -->
      <v-col cols="12" sm="2" md="2">
        <v-switch
          v-model="editedItem.Estado"
          color="red-darken-3"
          label="Estado"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Tipo de Respuesta -->
      <v-col v-if="editedItem.Tipo == TipoPlantilla.Email" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Tipo_Respuesta"
          :items="ArrayTipoRespuesta"
          :item-title="
            (ArrayTipoRespuesta) =>
              ArrayTipoRespuesta.Valor + '-' + ArrayTipoRespuesta.Descripcion
          "
          item-value="Valor"
          label="Tipo de Respuesta:"
          dense
          :rules="[rules.required]"
          @update:modelValue="editedItem.Email = null"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Email -->
      <v-col
        v-if="
          editedItem.Tipo == TipoPlantilla.Email &&
          editedItem.Tipo_Respuesta == TipoRespuestas.EmailSpecific
        "
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.Email"
          label="Email Remitente:"
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
          :rules="
            editedItem.Tipo == TipoPlantilla.Email &&
            editedItem.Tipo_Respuesta == TipoRespuestas.EmailSpecific
              ? [rules.required, rules.email]
              : []
          "
          clearable
        >
        </v-text-field>
      </v-col>

      <!-- Remitente -->
      <v-col v-if="editedItem.Tipo == TipoPlantilla.Email" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Remitente"
          label="Remitente:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Correo Copia -->
      <v-col v-if="editedItem.Tipo == TipoPlantilla.Email" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.CorreoEnvio_ID"
          :items="ArrayCorreosCopia"
          :item-title="
            (ArrayCorreosCopia) =>
              ArrayCorreosCopia.Id + '-' + ArrayCorreosCopia.NombrePerfil
          "
          item-value="Id"
          color="primary"
          label="Correos de Copia: "
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Asunto -->
      <v-col v-if="editedItem.Tipo == TipoPlantilla.Email" cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Asunto"
          label="Asunto:"
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="editedItem.Tipo == TipoPlantilla.Email ? [rules.required] : []"
          clearable
        >
        </v-text-field>
      </v-col>

      <!-- Mensajes -->
      <v-col
        v-if="
          editedItem.Tipo == TipoPlantilla.SMS || editedItem.Tipo == TipoPlantilla.Llamada
        "
        cols="12"
        sm="6"
        md="12"
      >
        <v-textarea
          v-model="editedItem.Mensajes"
          name="input-7-1"
          filled
          label="Mensaje:"
          auto-grow
          clearable
          counter="600"
          :rules="
            editedItem.Tipo == TipoPlantilla.SMS ||
            editedItem.Tipo == TipoPlantilla.Llamada
              ? [rules.required]
              : []
          "
        ></v-textarea>
      </v-col>
    </v-row>

    <div
      v-if="editedItem.Tipo == TipoPlantilla.Email"
      :class="['editor-page', { fullscreen: pantallaCompleta }]"
    >
      <div class="content">
        <div class="panel">
          <h3>HTML</h3>

          <textarea
            :rules="editedItem.Tipo == TipoPlantilla.Email ? [rules.required] : []"
            v-model="editedItem.Mensajes"
            class="html-editor"
          ></textarea>
        </div>

        <div class="panel">
          <h3>Vista previa</h3>

          <iframe class="preview" :srcdoc="editedItem.Mensajes"></iframe>
        </div>
      </div>
    </div>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
  getPlantillaEspecifica,
} from "@/views/TCI/Parametros/Plantillas/PlantillaService";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import {
  TipoPlantilla,
  TipoRespuestas,
  PlantillaId,
} from "@/views/TCI/Parametros/Constantes/ConstantesParametros";
import { getConsultAllList } from "@/views/TCI/Seguridad/Links/LinksServices";

export default {
  name: "rop-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    perfilId: {
      type: Number,
      default: 0,
      Description: "Información de perfilId para consulta de consecutivo",
    },
  },
  data() {
    return {
      TablaSeleccion,
      TipoPlantilla,
      TipoRespuestas,
      PlantillaId,
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Id: 0,
        DescPlantilla_ID: null,
        Tipo: null,
        Tipo_Respuesta: null,
        Email: null,
        CorreoEnvio_ID: null,
        MaxCaracteres: null,
        Remitente: null,
        Asunto: null,
        Mensajes: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Id: 0,
        DescPlantilla_ID: null,
        Tipo: null,
        Tipo_Respuesta: null,
        Email: null,
        CorreoEnvio_ID: null,
        MaxCaracteres: null,
        Remitente: null,
        Asunto: null,
        Mensajes: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayCorreosCopia: [],
      ArrayTipoPlantilla: [],
      ArrayTipoRespuesta: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Correos de Copia
    async getCorreosCopia() {
      this.ArrayCorreosCopia = [];
      const result = await getConsultAllList();
      this.ArrayCorreosCopia = result;
    },

    // Consulta Plantilla Especifica
    async plantillaEspecifica() {
      if (this.editedItem.Tipo != TipoPlantilla.Email) {
        return;
      }

      const result = await getPlantillaEspecifica(PlantillaId.PlantillaEspecifica);

      if (result) {
        this.editedItem.Remitente = result.Remitente;
        this.editedItem.Asunto = result.Asunto;
        this.editedItem.Mensajes = result.Mensajes;
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    ChangeTipoPlantilla() {
      this.editedItem.Tipo_Respuesta = null;
      this.editedItem.Email = null;
      this.editedItem.CorreoEnvio_ID = null;
      this.editedItem.MaxCaracteres = null;
      this.editedItem.Remitente = null;
      this.editedItem.Asunto = null;
      this.editedItem.Mensajes = null;

      this.plantillaEspecifica();
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      this.getCorreosCopia();

      this.ArrayTipoPlantilla = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoPlantilla
      );

      this.ArrayTipoRespuesta = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoRespuesta
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>

<style scoped>
.editor-page {
  width: 100%;
  height: calc(100vh - 80px);
  background: #f4f4f4;
  padding: 10px;
  box-sizing: border-box;
}

.editor-page.fullscreen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  height: 100vh;
  background: white;
}

.toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  height: calc(100% - 50px);
}

.panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.panel h3 {
  margin: 0 0 8px;
}

.html-editor {
  flex: 1;
  width: 100%;
  resize: none;
  padding: 12px;
  font-family: Consolas, monospace;
  font-size: 14px;
  border: 1px solid #ccc;
  outline: none;
  box-sizing: border-box;
}

.preview {
  flex: 1;
  width: 100%;
  border: 1px solid #ccc;
  background: white;
}
</style>
